<template>
  <div
    class="home-services container has-text-centered p-t-xl p-b-xl p-l-md p-r-md"
  >
    <div class="columns">
      <div class="column">
        <div class="m-b-xl">
          <h3 class="is-size-3 has-text-weight-bold">
            Servicios Casa Administraciones
          </h3>
          <p class="subtitle has-text-weight-medium">
            Administracion de inmuebles con propietarios e inquilinos contentos
          </p>
        </div>
      </div>
    </div>
    <div class="columns p-b-xl">
      <div class="column is-4">
        <div class="service has-text-centered">
          <figure class="image is-64x64 is-inline-block m-b-md">
            <img src="@/assets/icons/rentasplus.svg" alt="Rentas plus" />
          </figure>
          <div class="has-text-weight-bold m-b-sm m-t-md">Rentas plus</div>
          <p class="m-b-md">
            Es el servicio de <br />
            Casa Administraciones que acompaña<br />de manera personalizada
          </p>
          <div
            class="has-text-link has-text-weight-bold cursor-pointer"
            @click="goTo('rentas-plus')"
          >
            Más información
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="service has-text-centered">
          <figure class="image is-64x64 is-inline-block m-b-md">
            <img src="@/assets/icons/hand-house.svg" alt="Mantenimiento" />
          </figure>
          <div class="has-text-weight-bold m-b-sm m-t-md">Mantenimiento</div>
          <p class="m-b-md">
            Creado con la finalidad de mantener<br />en condiciones
            habitables<br />
            los inmuebles a la entrada, durante y<br />salida del inquilino.
          </p>
          <div
            class="has-text-link has-text-weight-bold cursor-pointer"
            @click="goTo('mantenimiento')"
          >
            Más información
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="service has-text-centered">
          <figure class="image is-64x64 is-inline-block m-b-md">
            <img
              src="@/assets/icons/balance.svg"
              alt="Asesoría jurídico y fiscal"
            />
          </figure>
          <div class="has-text-weight-bold m-b-sm m-t-md">
            Asesoría jurídico y fiscal
          </div>
          <p class="m-b-md">
            Para propietarios e inquilinos en<br />Casa Administraciones
            recibirá la<br />asesoría y acompañamiento en todos los<br />trámites
            para dejar su propiedad<br />con nosotros o rentar un inmueble
            nuestro
          </p>
          <div
            class="has-text-link has-text-weight-bold cursor-pointer"
            @click="goTo('asesoria')"
          >
            Más información
          </div>
        </div>
      </div>
    </div>
    <div class="services-banner hero is-primary p-md">
      <div class="columns is-tablet">
        <div class="column is-one-half-tablet is-relative">
          <img
            src="@/assets/images/services-banner.png"
            class="banner-image is-hidden-mobile"
            alt="buscas vender o rentar tu propiedad"
          />
        </div>
        <div class="column is-6 content-with-paddig">
          <div class="content has-text-left-tablet">
            <div class="has-text-weight-bold is-size-5 m-b-sm">
              ¿Buscas vender o rentar tu propiedad?
            </div>
            <p>
              Ayudamos a que su propiedad sea rentada de manera segura y reciba
              su dinero puntual
            </p>
            <b-button
              type="is-primary-green"
              class="has-text-weight-semibold"
              @click="$router.push({ name: 'manage-properties' })"
            >
              Vende o renta tu propiedad
            </b-button>
          </div>
        </div>
        <div class="column is-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeServices",
  methods: {
    goTo(section) {
      const query = {};
      query.s = section;
      this.$router.push({ name: "manage-properties", query });
    }
  }
};
</script>

<style lang="scss" scoped>
.content-with-paddig {
  padding: 1.5rem 0;
}

.home-services .services-banner {
  border-radius: $radius-large;
  max-width: 976px;
  margin: 0 auto;
}

.banner-image {
  position: absolute;
  left: -24px;
  bottom: 0px;
}

.service figure {
  border-radius: 4px;
  background-color: $white;
  box-shadow: 0 6px 8px 2px rgba(26, 66, 117, 0.15);
  padding: 0.8em;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
